import React from 'react';

import { generateCardProps } from '../../../utils/subscriptionCardOptions';
import { CorporateSubscriptionCard, SubscriptionOptionCard } from '../../shared';
import marketingModalStyles from '../Layout/styles.module.scss';
import styles from './styles.module.scss';

const StandardSubscriptionModalBody = ({ disclosure, guid, trackingProps }) => {
  const hrefParams = { modal: guid };

  return (
    <div>
      <div className={styles.subscriptionCardsContainer}>
        {[
          generateCardProps({
            planType: 'monthly',
            hrefParams,
            trackingProps: { ...trackingProps, name: 'monthly_subscribe' },
          }),
          generateCardProps({
            planType: 'annual',
            hrefParams,
            trackingProps: { ...trackingProps, name: 'annual_subscribe' },
          }),
          generateCardProps({
            planType: 'young_professionals',
            hrefParams,
            trackingProps: { ...trackingProps, name: 'yp_subscribe' },
          }),
        ].map((cardProps) => {
          return (
            <SubscriptionOptionCard
              key={cardProps.title}
              customStyles={styles.optionCard}
              {...cardProps}
            />
          );
        })}
        <CorporateSubscriptionCard
          trackingProps={{ ...trackingProps, name: 'corporate_subscribe' }}
        />
      </div>
      {disclosure && <div className={marketingModalStyles.disclosure}>{disclosure}</div>}
    </div>
  );
};

export default StandardSubscriptionModalBody;
